import React, { useEffect, useState } from "react";
import "./App.scss";
import MainRoute from "./routes/main.routes";
import { User } from "./@types/user.interface";
import { removeCookie, getCookie } from "./redux/utils/cookie";
import { GlobalState } from "./redux/root-reducer";
import { Dispatch } from "redux";
import { fetchApi } from "./redux/fetch/fetch.actions";
import { connect } from "react-redux";
import { useHistory, Redirect } from "react-router-dom";
import LoginPage from "./pages/login-page/login-container.component";
import Loading from "./components/loading/loading.component";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    user: User | null;
    checkUser: () => void;
}

function AppContainer({ isFetching, errors, user, checkUser }: IProps) {
    const history = useHistory();
    const [check, setCheck] = useState(false);

    useEffect(() => {
        if (isFetching) return;
        if (errors) {
            removeCookie("_s");
            history.replace("/login");
        }
        if (getCookie("_s") && user === null) {
            checkUser();
        }
        setCheck(true);
    }, [isFetching, errors, checkUser, user, history]);

    if (isFetching || check === false) {
        return <Loading className="fixed" />;
    }

    return (
        <div className="App">
            {user || getCookie("_s") ? (
                <MainRoute />
            ) : (
                <>
                    <Redirect to="/login" />
                    <LoginPage />
                </>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: {
        self: { data },
    },
}: GlobalState) => ({
    isFetching: isFetching.CHECK_USER,
    errors: errors.CHECK_USER,
    user: data,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    checkUser: () => dispatch(fetchApi({ name: "CHECK_USER" })),
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppContainer);
export default App;
